import type { LoginErrorType } from '@/scopes/auth/domain/types'
import { useIntl } from '@/intl'
import { useAuthStore } from '@/scopes/auth/infrastructure/useAuthStore'
import { getRetryAfterMinutes } from '@/scopes/auth/pages/selectors/authSelectors'
import { AuthErrorBanner } from '../AuthErrorBanner'

const LOGIN_ERROR_TRANSLATION_KEY: Record<LoginErrorType, string> = {
  validationFailed: 'auth_login_form_error_generic',
  invalidCredentials: 'auth_login_form_error_invalid_credentials',
  accountNotVerified: 'auth_login_form_error_account_not_verified',
  weakPassword: 'auth_login_form_error_weak_password',
  rateLimited: 'auth_login_form_error_rate_limited',
  unexpectedError: 'auth_login_form_error_generic',
}

export function LoginErrorBanner() {
  const intl = useIntl()
  const error = useAuthStore(state => state.submitError)
  const minutesLeftBlocked = useAuthStore(getRetryAfterMinutes)

  if (!error)
    return null

  return (
    <AuthErrorBanner
      message={intl.formatMessage(
        { id: LOGIN_ERROR_TRANSLATION_KEY[error.type] },
        { minutesLeftBlocked },
      )}
    />
  )
}
